// App.js
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Users from "./pages/Users";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import Devices from "./pages/Devices";
import MikrotikUsers from "./pages/MikrotikUsers";
import ProfileManager from "./pages/ProfileManager";
import PPP from "./pages/PPP";
import PPPWfh from "./pages/PPPWfh";
import PppSecrets from "./pages/PppSecrets";
import AllPppSecret from "./pages/PppSecretsAll";
import WfhPppSecret from "./pages/PppSecretsWfh";
import PppProfiles from "./pages/PppProfiles";
import PppActiveCon from "./pages/PPPActiveCons";
import Product from "./pages/Product";
import ProductGroups from "./pages/ProductGroups";
import Orders from "./pages/Orders";
import Transactions from "./pages/Transactions";
import UsermanUsers from "./pages/UsermanUsers";
import UsermanProfiles from "./pages/UsermanProfiles";
import UsermanUserProfile from "./pages/UsermanUserProfile";
import UsermanLimitation from "./pages/UsermanLimitation";
import UsermanProfileLimitation from "./pages/UsermanProfileLimitation";
import UsermanAttribute from "./pages/UsermanAttribute";
import UsermanRouter from "./pages/UsermanRouter";
import UsermanUserGroup from "./pages/UsermanUserGroup";
import UsermanSession from "./pages/UsermanSession";
import Customer from "./pages/Customer";
import CustomerDetail from "./pages/CustomerDetail";
import CustomerDashboard from "./pages/CustomerDashboard";
import Hotspot from "./pages/Hotspot";
import DisabledListPage from "./pages/DisabledList";
import DisabledListWfhPage from "./pages/DisabledListWfh";
import DismantleList from "./pages/Dismantle";
import Invoices from "./pages/Invoices";
import InvoiceDetail from "./pages/InvoiceDetail";
import InovasiTransaction from "./pages/InovasiTransactions";
import ActivityLogPage from "./pages/RecentActivities";

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen((prev) => !prev);
  }, []);

  // Cek token & user saat mount dan saat localStorage berubah
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("token");
      const userRaw = localStorage.getItem("user");

      let userData = null;
      try {
        userData = userRaw ? JSON.parse(userRaw) : null;
      } catch (error) {
        console.error("Failed to parse user data from localStorage:", error);
      }

      setIsLoggedIn(!!token && !!userData);
      setUser(userData);
    };

    checkAuth();
    window.addEventListener("storage", checkAuth);
    return () => window.removeEventListener("storage", checkAuth);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setIsLoggedIn(false);
    setUser(null);
    window.location.href = "/"; // Tetap gunakan ini di App.js karena berada di luar Router context
  };

  const role = user?.role || "member";
  // const role = "billing";
  // const role = "NOC-WFH";

  return (
    <BrowserRouter>
      <div className="flex bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100 min-h-screen">
        {isLoggedIn && (
          <Sidebar
            role={role}
            onLogout={handleLogout}
            isOpen={isSidebarOpen}
            toggleSidebar={toggleSidebar}
          />
        )}

        <div
          className={`flex-1 transition-all duration-300 ${
            isLoggedIn ? (isSidebarOpen ? "md:ml-64" : "md:ml-20") : "ml-0"
          }`}
        >
          {isLoggedIn && <Navbar toggleSidebar={toggleSidebar} user={user} />}

          <Routes>
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="/devices"
              element={
                <ProtectedRoute>
                  <Devices />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mikrotikusers"
              element={
                <ProtectedRoute>
                  <MikrotikUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profilemanager"
              element={
                <ProtectedRoute>
                  <ProfileManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/userman-users"
              element={
                <ProtectedRoute>
                  <UsermanUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/userman-user-group"
              element={
                <ProtectedRoute>
                  <UsermanUserGroup />
                </ProtectedRoute>
              }
            />
            <Route
              path="/userman-session"
              element={
                <ProtectedRoute>
                  <UsermanSession />
                </ProtectedRoute>
              }
            />
            <Route
              path="/userman-profiles"
              element={
                <ProtectedRoute>
                  <UsermanProfiles />
                </ProtectedRoute>
              }
            />
            <Route
              path="/userman-router"
              element={
                <ProtectedRoute>
                  <UsermanRouter />
                </ProtectedRoute>
              }
            />
            <Route
              path="/userman-user-profile"
              element={
                <ProtectedRoute>
                  <UsermanUserProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/userman-limitation"
              element={
                <ProtectedRoute>
                  <UsermanLimitation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/userman-profile-limitation"
              element={
                <ProtectedRoute>
                  <UsermanProfileLimitation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/userman-attribute"
              element={
                <ProtectedRoute>
                  <UsermanAttribute />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ppp"
              element={
                <ProtectedRoute>
                  <PPP />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ppp-wfh"
              element={
                <ProtectedRoute>
                  <PPPWfh />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ppp-secrets"
              element={
                <ProtectedRoute>
                  <PppSecrets />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ppp-secrets-all"
              element={
                <ProtectedRoute>
                  <AllPppSecret />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ppp-secrets-wfh"
              element={
                <ProtectedRoute>
                  <WfhPppSecret />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ppp-profiles"
              element={
                <ProtectedRoute>
                  <PppProfiles />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ppp-active-cons"
              element={
                <ProtectedRoute>
                  <PppActiveCon />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customers"
              element={
                <ProtectedRoute>
                  <Customer role={role} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer-dashboard"
              element={
                <ProtectedRoute>
                  <CustomerDashboard role={role} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/disabled-list"
              element={
                <ProtectedRoute>
                  <DisabledListPage role={role} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/disabled-list-wfh"
              element={
                <ProtectedRoute>
                  <DisabledListWfhPage role={role} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dismantle-list"
              element={
                <ProtectedRoute>
                  <DismantleList role={role} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer-detail/:cust_id"
              element={
                <ProtectedRoute>
                  <CustomerDetail role={role} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoices"
              element={
                <ProtectedRoute>
                  <Invoices role={role} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoice-detail/:id"
              element={
                <ProtectedRoute>
                  <InvoiceDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inovasi-transactions"
              element={
                <ProtectedRoute>
                  <InovasiTransaction />
                </ProtectedRoute>
              }
            />
            <Route
              path="/products"
              element={
                <ProtectedRoute>
                  <Product role={role} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/productgroups"
              element={
                <ProtectedRoute>
                  <ProductGroups role={role} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hotspot"
              element={
                <ProtectedRoute>
                  <Hotspot />
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders"
              element={
                <ProtectedRoute>
                  <Orders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transactions"
              element={
                <ProtectedRoute>
                  <Transactions role={role} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/recent-activities"
              element={
                <ProtectedRoute>
                  <ActivityLogPage role={role} />
                </ProtectedRoute>
              }
            />
            <Route
              path="*"
              element={
                <div className="p-10 text-center">404 - Page Not Found</div>
              }
            />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
